<template>
  <div v-if="dataVal.listIsShow" class="pricing-list">
    <div class="totle">
      共计<span>{{ dataVal.borrowingList.length }}</span>条
    </div>
    <div
        class="pricing-item"
        v-for="(item, index) in dataVal.borrowingList"
        :key="index"
        ref="itm"
        @click="look(index, item)"
    >
      <div class="title">借用记录</div>
      <div class="applicant-time clearfix">
        <div class="applicant">
          借用人：{{ item.BorrowingInformation.BorrowerName }}
          {{ item.BorrowingInformation.BorrowerEmpNo }}
          {{ item.BorrowingInformation.BorrowerDept }}
        </div>
        <div class="applicant">
          设备名称: {{ item.BorrowingInformation.EquipmentName }}
        </div>
        <div class="applicant">
          借用时间: {{ item.BorrowingInformation.BorrowingStartTime }}-{{
            item.BorrowingInformation.BorrowingEndTime
          }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['dataVal'],
  data() {
    return {
      borrowings:[]
    }
  },
  mounted() {
  },
  methods: {
    look(index,item){
      let thisClassObj = this.$refs.itm[index]
      if(thisClassObj.className === "pricing-item"){
        this.$refs.itm[index].className = "pricing-item pricing-list-current";
        this.borrowings.push(item)
      }else{
        this.$refs.itm[index].className = "pricing-item";
        this.borrowings = this.borrowings.filter(e => e.ID !== item.ID)
      }
      this.$emit("look",this.dataVal,this.borrowings);
    }
  }

}
</script>

<style lang="less" scoped>
.pricing-list {
  padding: 10px;
  margin-top: 0px;

  .totle {
    font-size: 12px;
    margin-top: 10px;

    span {
      color: #ff4346;
      padding: 0 4px;
    }
  }

  .pricing-item {
    width: 100%;
    background: #ffffff;
    position: relative;
    padding: 8px;
    margin-top: 10px;
    border-radius: 6px;
    box-shadow: 6px 6px 6px #cccccc;

    .title {
      font-size: 13px;
      color: #585354;
      line-height: 1.8;
      width: calc(100% - 40px);
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
      padding-bottom: 4px;
    }

    .applicant-time {
      color: #585354;
      font-size: 12px;
      line-height: 1.7;

      div.applicant {
        width: 80%;
        float: left;
      }

      div.time {
        width: 40%;
        float: right;
        text-align: right;
      }
    }

    .label {
      position: absolute;
      right: 5px;
      top: 10px;
    }

    .waiting-pricing {
      color: #3fc243;
    }

    .waiting-check {
      color: #55acee;
    }
  }

  .pricing-list-current {
    border: 2px solid #b9d5ec;
    box-shadow: 6px 6px 6px #78b4e6;
  }

  .pricing-item:first-child {
    margin-top: 0;
  }
}
</style>